<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content">
      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Add a Workstation</p>
          <button
            class="delete"
            aria-label="close"
            @click="close(true)">
          </button>
        </header>

        <v-form class="modal-card-body" :valid.sync="valid">

          <div class="field">
            <label class="label">Workstation Name*</label>
            <v-text-field 
              required
              placeholder="Enter Workstation Name"
              v-model="workstation.workstation_name">
            </v-text-field>
          </div>

          <div class="field">
            <label class="label">Workstation Description</label>
            <v-text-area 
              placeholder="Enter Workstation Description"
              rows="3"
              v-model="workstation.desc">
            </v-text-area>
          </div>

          <div class="field">
            <label class="label">Daily Capacity (Minutes)</label>
            <v-text-field 
              type="number"
              placeholder="Daily capacity in minutes"
              v-model="workstation.capacity_minutes">
            </v-text-field>
          </div>

          <div class="field">
            <label class="label">Workstation Status</label>
            <v-select 
              required
              :options="statuses"
              v-model="workstation.status"
            />
          </div>

          <div class="field">
            <v-checkbox
              label="Workstation is currently active"
              v-model="workstation.is_active"/>
          </div>

          <hr/>

          <label class="label">
            Assign Work Steps
          </label>
          <div class="help mb-2">
            This determine the types of tasks that the workstation can work on
          </div>

          <v-checkbox 
            v-for="workStep in workSteps" 
            :value="workstationWorkSteps.includes(workStep.id)"
            @input="toggleWorkStep(workStep.id)"
            :label="workStep.work_name"
            :key="workStep.id"/>

        </v-form>

        <footer class="modal-card-foot">
          <button 
            :disabled="!valid"
            class="button is-primary" 
            @click.stop="addNew()">
            Save
          </button>
          <button 
            class="button" 
            @click.stop="close(true)">
            Cancel
          </button>
        </footer>

      </div>
    </div>

  </div>
</template>

<script>
import VCheckbox from '@/components/base/VCheckbox'
import VTextArea from '@/components/base/VTextArea'
import VSelect from '@/components/base/VSelect'
import VTextField from '@/components/base/VTextField'
import VForm from '@/components/base/VForm'

import { mapState, mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean
    }
  },
  components: { 
    VTextArea,
    VTextField, 
    VForm, 
    VSelect,
    VCheckbox
  },
  data() {
    return {
      workstation: {
        workstation_name: null,
        desc: null,
        capacity_minutes: null,
        status: null,
        is_active: false
      },
      workstationWorkSteps: [],
      valid: false,
    }
  },
  computed: {
    ...mapState("workstations", [
      "statuses"
    ]),
    ...mapState("workSteps", [
      "workSteps"
    ])
  },
  watch: {
    'workstation.status'(status) {
      if (status == 'Active') {
        this.workstation.is_active = true;
      } else {
        this.workstation.is_active = false;
      }
    },
    'workstation.is_active'(v) {
      if (v) {
        this.workstation.status = 'Active';
      } else {
        this.workstation.status = 'Inactive';
      }
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("workstations", [
      "addWorkstation", "addWorkstationWorkStep"
    ]),
    ...mapActions("workSteps", ["getWorkSteps"]),
    initialize() {
      if (this.workSteps.length == 0) {
        this.getWorkSteps();
      }
    },
    addNew() {
      this.addWorkstation({ 
        data: this.workstation
      }).then(resp => {
        if (this.workstationWorkSteps.length > 0) {
          this.addWorkSteps(resp.data.id);
        } else {  
          this.close(true);
        }
      });
    },
    addWorkSteps(workstationId) {
      let promises = [];
      this.workstationWorkSteps.forEach(workStepId => {
        promises.push(
          this.addWorkstationWorkStep({
            workstation_id: workstationId,
            work_step_id: workStepId,
          })
        );
      });
      Promise.all(promises).then(() => {
        this.close(true);
      });
    },
    toggleWorkStep(workStepId) {
      let index = this.workstationWorkSteps.indexOf(workStepId);
      if (index == -1) {
        this.workstationWorkSteps.push(workStepId);
      } else {
        this.workstationWorkSteps.splice(index, 1);
      }
    },
    close(clear=false) {
      this.$emit('input', false);
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>
